<div class="todo-sidenav">
  <div class="todo-header">
    <h3>To-Do List</h3>
    <button mat-icon-button (click)="close()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <div class="todo-content">
    <!-- Leads Responded -->
    <div *ngIf="leadsResponded.length; else noLeadsResponded" class="section responded">
      <h4>Message recieved (Last 7 Days) - Total({{leadsRespondedTotal}})</h4>
      <ul>
        <li *ngFor="let lead of leadsResponded" class="item">
          <mat-icon class="icon">person</mat-icon>
          <div class="details">
            <span>{{ lead.fullName || 'N/A' }}</span>
            <span>{{ lead.email || 'N/A' }}</span>
            <span>{{ lead.last_incoming_message_time ? (lead.last_incoming_message_time | date:'short') : 'N/A' }}</span>
          </div>
          <button mat-icon-button (click)="redirectToMessage(lead)">
            <mat-icon class="eye-icon">visibility</mat-icon>
          </button>
        </li>
      </ul>
      <button mat-button (click)="loadMore('leadsResponded')" *ngIf="leadsResponded.length < leadsRespondedTotal">See More</button>
    </div>
    <ng-template #noLeadsResponded><p class="no-data">No responded leads.</p></ng-template>

    <!-- New Leads -->
    <div *ngIf="newLeads.length; else noNewLeads" class="section new-leads">
      <h4>New Leads - Total({{newLeadsTotal}})</h4>
      <ul>
        <li *ngFor="let lead of newLeads" class="item">
          <mat-icon class="icon">person_add</mat-icon>
          <div class="details">
            <span>{{ lead.fullName || 'N/A' }} - {{ lead?.campus?.name || 'N/A' }}</span>
            <span>{{ lead?.program?.name || 'N/A' }}</span>
            <span>{{ lead?.prefix || '' }}{{ lead?.phoneNumber || 'N/A' }}</span>
          </div>
          <button mat-icon-button (click)="redirectToLead(lead)">
            <mat-icon class="eye-icon">visibility</mat-icon>
          </button>
        </li>
      </ul>
      <button mat-button (click)="loadMore('newLeads')" *ngIf="newLeads.length < newLeadsTotal">See More</button>
    </div>
    <ng-template #noNewLeads><p class="no-data">No new leads.</p></ng-template>

    <!-- Today's Activities -->
    <div *ngIf="todayActivities.length; else noActivities" class="section activities">
      <h4>Today's Activities - Total({{todayActivitiesTotal}})</h4>
      <ul>
        <li *ngFor="let task of todayActivities" class="item">
          <mat-icon class="icon">{{ task?.type?.icon || 'event' }}</mat-icon>
          <div class="details">
            <span>{{ task.title || 'N/A' }}</span>
            <span>{{ task.startDate ? (task.startDate | date:'shortTime') : 'N/A' }} - {{ task.endDate ? (task.endDate | date:'shortTime') : 'N/A' }}</span>
          </div>
          <button mat-icon-button (click)="redirectToTask(task)">
            <mat-icon class="eye-icon">visibility</mat-icon>
          </button>
        </li>
      </ul>
      <button mat-button (click)="loadMore('todayActivities')" *ngIf="todayActivities.length < todayActivitiesTotal">See More</button>
    </div>
    <ng-template #noActivities><p class="no-data">No activities for today.</p></ng-template>

  </div>

  <div class="todo-footer">
    <p class="footer-text">© 2025 Dostify CRM. All rights reserved.</p>
    <button mat-button (click)="close()" class="footer-button">Close</button>
  </div>
</div>
